import styled, { css, keyframes } from 'styled-components'
import { BalloonHintProps } from './types'
import { BadgePosition } from '../../types'

const balloonKeyframes = keyframes`
0% {
  opacity: 0;
}
100% {
  opacity: 1;
}
`

const balloonLayout = {
  default: () => css``
}
balloonLayout[BadgePosition.TopLeft] = (
  parentHeight: number,
  margin: number
) => css`
  left: calc(${margin}px + 3px);
  top: calc(${parentHeight}px + ${margin}px + 11px);
`
balloonLayout[BadgePosition.TopRight] = (
  parentHeight: number,
  margin: number
) => css`
  right: calc(${margin}px + 3px);
  top: calc(${parentHeight}px + ${margin}px + 11px);
`
balloonLayout[BadgePosition.BottomLeft] = (
  parentHeight: number,
  margin: number
) => css`
  left: calc(${margin}px + 3px);
  bottom: calc(${parentHeight}px + ${margin}px + 11px);
`
balloonLayout[BadgePosition.BottomRight] = (
  parentHeight: number,
  margin: number
) => css`
  right: calc(${margin}px + 3px);
  bottom: calc(${parentHeight}px + ${margin}px + 11px);
`

const balloonTipLayout = {
  default: css``
}
balloonTipLayout[BadgePosition.TopLeft] = css`
  left: 16px;
  top: -4px;
`
balloonTipLayout[BadgePosition.TopRight] = css`
  right: 16px;
  top: -4px;
`
balloonTipLayout[BadgePosition.BottomLeft] = css`
  left: 16px;
  bottom: -4px;
`
balloonTipLayout[BadgePosition.BottomRight] = css`
  right: 16px;
  bottom: -4px;
`

export const Balloon = styled.div.attrs((props: BalloonHintProps) => props)`
  animation: ${balloonKeyframes} 0.75s ease;
  background-color: ${({ bgColor }) => bgColor};
  border-radius: 4px;
  position: fixed;

  ${({ position, parentHeight, parentOffset }) =>
    balloonLayout[position || 'default'](parentHeight, parentOffset)}
  width: ${({ width }) => (width && isNaN(width) ? width : `${width}px`)};

  div.contents {
    color: ${({ fontColor }) => fontColor};
    margin: ${({ margin }) => margin}px;
    font-size: ${({ fontSize }) => fontSize};
    line-height: 1.5;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
      'Helvetica Neue', sans-serif;
    text-align: center;
  }

  div.balloonTip {
    border-bottom: 8px solid ${({ bgColor }) => bgColor};
    border-right: 8px solid ${({ bgColor }) => bgColor};
    height: 0px;
    position: absolute;
    transform: rotate(-45deg);
    width: 0px;
    ${({ position }) => balloonTipLayout[position] || balloonTipLayout.default}
  }
`
